// ============================================================================
// COMPONENT — ResourceFileList.jsx
// components/ResourceFileList.jsx
// ============================================================================

import React from 'react';
import './ResourceFileList.css';

const ResourceFileList = ({
  fileIds = [],
  fileNames = [],
  onDownload,
  editMode = false,
  onRemove,
  newFiles,
  onAddFiles,
  onRemoveNew,
  uploading = false,
  uploadProgress,
}) => {
  const hasExisting = fileIds.length > 0;
  const hasNew      = newFiles && newFiles.length > 0;

  if (!hasExisting && !editMode && !hasNew) return null;

  return (
    <div className="rfl">
      {hasExisting && (
        <div className="rfl-list">
          {fileIds.map((id, i) => (
            <div key={id} className="rfl-item">
              <span className="rfl-item-icon">📄</span>
              <span className="rfl-item-name">{fileNames[i] || `File ${i + 1}`}</span>
              <div className="rfl-item-actions">
                {onDownload && (
                  <button className="rfl-btn rfl-btn--dl" onClick={() => onDownload(id, fileNames[i])} title="Download">⬇</button>
                )}
                {editMode && onRemove && (
                  <button className="rfl-btn rfl-btn--rm" onClick={() => onRemove(i)} title="Remove">✕</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {editMode && onAddFiles && (
        <label className="rfl-upload">
          <input type="file" multiple className="rfl-upload-input"
            onChange={(e) => onAddFiles(e.target.files)} />
          <span className="rfl-upload-icon">📎</span>
          <span className="rfl-upload-label">Attach files</span>
          <span className="rfl-upload-hint">PDF, DOC, PPT, Images, ZIP</span>
        </label>
      )}

      {hasNew && (
        <div className="rfl-list rfl-list--new">
          {Array.from(newFiles).map((f, i) => (
            <div key={i} className="rfl-item rfl-item--new">
              <span className="rfl-item-icon">📄</span>
              <span className="rfl-item-name">{f.name}</span>
              <span className="rfl-item-size">{(f.size / 1024).toFixed(0)} KB</span>
              {onRemoveNew && <button className="rfl-btn rfl-btn--rm" onClick={() => onRemoveNew(i)}>✕</button>}
            </div>
          ))}
        </div>
      )}

      {uploading && (
        <div className="rfl-progress">
          <span className="rfl-progress-spin" />
          <span>{uploadProgress || 'Uploading…'}</span>
        </div>
      )}
    </div>
  );
};

export default ResourceFileList;
